// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__1fSK0","second":"return_second__1k_kS","link":"return_link__KGLA5"};